import React from 'react';
import { Field } from '../../components/ui';

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--line)', fontSize: 14 }}>
    <span className="muted">{label}</span>
    <span style={{ fontWeight: 600, textAlign: 'right' }}>{value || '—'}</span>
  </div>
);

// Mobile (APK) Profile — centred avatar, full-width stacked buttons.
export default function ProfileMobile({ vm }) {
  const { user, organiser, roleLabel, fullName, avatar, editing, setEditing, saving, form, setF, saveProfile, doLogout, goChangePassword } = vm;
  return (
    <div>
      <div className="card card-pad mobile-record-card">
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div className="avatar avatar-lg" style={{ margin: '0 auto 8px' }}>{avatar}</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{fullName || '—'}</div>
          <div className="muted" style={{ fontSize: 13 }}>{roleLabel} · #{user?.UserId}</div>
        </div>

        {editing ? (
          <div>
            <Field label="Name" value={form.Name} required onChange={v => setF('Name', v)} />
            <Field label="Surname" value={form.Surname} onChange={v => setF('Surname', v)} />
            <Field label="Mobile Number" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
            <Field label="Email" value={form.EmailId} onChange={v => setF('EmailId', v)} />
            <Field label="New Password" type="password" value={form.Password}
              onChange={v => setF('Password', v)} placeholder="Leave blank to keep current" />
            <Field label="Confirm Password" type="password" value={form.ConfirmPassword}
              onChange={v => setF('ConfirmPassword', v)} />
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button className="btn light" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={() => setEditing(false)}>Cancel</button>
              <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={saveProfile}>{saving ? 'Saving...' : 'Save'}</button>
            </div>
          </div>
        ) : (
          <>
            <Row label="Mobile" value={user?.MobileNumber} />
            <Row label="Email" value={user?.EmailId} />
            <Row label="Organiser" value={organiser?.OrganiserName} />
            <button className="btn primary" style={{ width: '100%', padding: 12, marginTop: 14 }} onClick={() => setEditing(true)}>Edit Profile</button>
            <button className="btn light" style={{ width: '100%', padding: 12, marginTop: 8 }} onClick={goChangePassword}>Change password</button>
            <button className="btn danger" style={{ width: '100%', padding: 12, marginTop: 8 }} onClick={doLogout}>Logout</button>
          </>
        )}
      </div>
    </div>
  );
}
